const Form073EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        BasicInfo: "Basic Information",
        SNG: "Application Form Selection",
        SectionA: "Section A",
        SectionB: "Section B",
        Certification: "Certification",
        Confirmation: "Confirmation",
    },
    stepTitle: {
        supplyTitle: "Application document",
    },

    notes: {
        noteTitle: "Personal Information Collection Statement",
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
        notesNum: {
            a: "(a)",
            b: "(b)",
            c: "(c)",
            d: "(d)",
            e: "(e)",
            f: "(f)",
        },
        notesNumOption: {
            a: " processing employment-related matters;",
            b: " processing Salaries Grant payment and calculation of provident fund contribution and donation;",
            c: " auditing;",
            d: " conducting research and compiling statistics to facilitate planning of education services;",
            e: " processing matters relating to the development of the education profession;",
            f: " administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",
        },
        note2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        note4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },

    schoolCode: "School Code",
    month: "Month",
    year: "Year",
    sectionOption: {
        SectionA:
            "<b>Section A</b> Daily-rated supply non-teaching staff <b>not required</b> to contribute to MPF",
        SectionB:
            "<b>Section B</b> Daily-rated supply non-teaching staff <b>required</b> to contribute to MPF",
    },
    SectionATitle:
        "Section A Daily-rated supply non-teaching staff not required to contribute to MPF",
    SectionBTitle:
        "Section B Daily-rated supply non-teaching staff required to contribute to MPF",
    sectionNote: {
        s: "Section A ",
        ss: "Section B ",
        s1: "Daily-rated supply non-teaching staff ",
        s2: "not required ",
        s3: "required",
        s4: "to contribute to MPF",
    },
    srn: "SRN",
    post: "Post",
    postNum: "Number of post",
    absence: "Reason for absence",
    paidLeave: "Reason for other paid leave",
    workDay: "No. of working days",
    dailyRate: "Daily rate",
    salaryAmount: "Salary amount",
    salaryTotal: "Total of Salary Amount",
    mpfSubsidy: "MPF Subsidy",
    mpfSchemes: "Attachment for MPF Schemes",
    subsidyTotal: "Total of MPF Subsidy",
    label: {
        leaveFrom: "Leave period From",
        leaveTo: "Leave period To",
        supplyFrom: "Supply period From",
        supplyTo: "Supply period To",
        contractFrom: "Contract period From",
        contractTo: "Contract period To",
    },
    label2: {
        name: "Name",
        schoolName: "School Name",
        postName: "Number of post",
        supplyName: "Name of supply staff",
    },
    attachment:
        "Attachment(s) for the emoluments have been paid to the supply non-teaching staff and/or MPF scheme trustee concerned",
    signature: "Signature of Supervisor/School Head",
    date: "Date",
    contactPerson: "Contact Person",
    telNo: "Tel No.",
    ssdo: "SSDO",
    schoolChop: "School Chop",

    toolTips: {
        n1: "Enter Staff Reference Number of non-teaching staff on leave.",
        n2: "Enter the alphabet from the list of reasons for absence below - \n  For specialist staff/laboratory technician, \n   (a) paid sick/maternity/special tuberculosis leave; \n   (b) other paid leave (Please specify the reason); \n   (x) no-pay sick/maternity/special tuberculosis leave; \n   (z) other no-pay leave. \n  For other non-teaching staff, \n   (c) paid sick/maternity leave; \n   (d) other paid leave (Please specify the reason); \n   (y) no-pay sick/maternity leave; and \n   (z) other no-pay leave. \nPlease note that granting of leave should follow EDB Circular No. 1/2006.",
        n3: "The number of working days should exclude Sunday, Saturday (short-week), public holidays, discretionary holidays or any days on which the non-teaching staff is not required to perform duties.",
        n4: "Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers and supply staff in aided schools...",
        n5: "For supply period less than 60 calendar days yet the supply non-teaching staff is required to contribute to MPF, please provide supporting information.",
    },
    absenceTitle: {
        t1: "Choose the reasons for absence below –",
        t2: "For specialist staff/laboratory technician,",
        t3: "For other non-teaching staff,",
        t4: "Please note that granting of leave should follow EDB Circular No. 1/2006.",
    },
    absenceOptions1: {
        a: "(a) paid sick/maternity/special tuberculosis leave;",
        b: "(b) other paid leave <b>(Please specify the reason)</b>;",
        x: "(x) no-pay sick/maternity/special tuberculosis leave;",
        specialistZ: "(z) other no-pay leave.",
    },
    absenceOptions2: {
        c: "(c) paid sick/maternity leave;",
        d: "(d) other paid leave <b>(Please specify the reason)</b>;",
        y: "(y) no-pay sick/maternity leave; and",
        otherZ: "(z) other no-pay leave.",
    },
    certify: {
        that: "I certify that –",
        grant: "My school will refund to Government any over-payment of grant.",
        three: "I would like to request reimbursement of daily-rated supply non-teaching staff and/or employer’s contributions to Mandatory Provident Fund (MPF) as follows –",
    },
    certifyNoteNum: {
        one: "(i) ",
        two: "(ii) ",
    },
    certifyNote: {
        one: "the emoluments have been paid to the supply non-teaching staff and/or MPF scheme trustee concerned, relevant receipts being attached for your records; and",
        two: "no duplicate claim has been made for government subventions on account of the same leave set out in Sections A and B.",
    },

    sign: {
        adminType: "Supervisor/School Head",
        headerName: "Name of Supervisor/School Head",
        date: "Date",
        person: "Contact Person",
        telNo: "Tel No",
        chop: "(School chop)",
    },
    adminValue: {
        supervisor: "Supervisor",
        schoolHead: "School Head",
    },

    errorMsg: {
        limitsToDateRule:
            "To date cannot be later than 31 Aug of the subject school year",
        freezVacancy:
            "Revocable Freezing of Vacancy of Period must not be less than 30 calendar days",
        leavePeriod: "Leave Period must not be less than 30 calendar days",
        qualifiedPeriod:
            "Qualified Period must not be less than 30 calendar days",
        leaveDateRules: "The Leave Period is not less than 30 days",
        number: {
            digitOne: "This field must be at most 1 decimal places",
        },
        withinSupplyPeriod:
            "Contract period must be within the period of supply period",
    },
};
export default Form073EN;
